




























import { Component, Vue, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
@Component
export default class BottomNav extends Vue {
  private bottomNav: string = 'home';

  public mounted() {
    this.bottomNav = this.$route.path;
  }
}
